enum PlatformClientUserFilterQueryMode {
    NONE = 'NONE',
    JUMP_TO_CLIENT = 'JUMP_TO_CLIENT',
}

export default PlatformClientUserFilterQueryMode;
